/* eslint-disable complexity */
import { FormatsManager } from './formatting'

const formats = () => FormatsManager.getFormats()

export const DEFAULT_ERROR = '- -'
export const ROMANS = ['N', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX']

const wgsdkThousands = function(number) {
    const formatsData = formats()
    let dotted = ''
    number = number.toString()

    const dotPosition = number.search(/\./)
    if (dotPosition > -1) {
        dotted = ','
        if(formatsData) {
            dotted = formatsData.decimal || '.'
        }
        dotted += number.substr(dotPosition + 1)
        number = number.substr(0, dotPosition)
    }

    let sign = ''
    if (number.charAt(0) === '-') {
        number = number.substr(1)
        sign = '-'
    }

    const len = number.length
    let separator = ' '
    if (formatsData && formatsData.thousand) {
        separator = formatsData.thousand
    }

    let result = ''
    for (let i = 0; i < len; ++i) {

        if (i !== 0 && (len - i) !== 0 && (len - i) % 3 === 0) {
            result += separator
        }
        result += number.charAt(i)
    }
    return sign + result + dotted
}

export const compactNumber = function(value, reduceStartFrom = 10000) {
    value = parseInt(value, 10)
    if (isNaN(value)) {
        return DEFAULT_ERROR
    }
    let suffix = ''
    if (reduceStartFrom < 10000) {
        reduceStartFrom = 10000
    }

    if (value >= reduceStartFrom) {
        if (value >= 1000000) {
            value = value / 1000000
            suffix = ' M'
        } else {
            value = value / 1000
            suffix = ' K'
        }
    }

    if (suffix) {
        value = Math.floor(value * 100) / 100
        value = value.toFixed(2)
    }

    return wgsdkThousands(value) + suffix
}

export const thousands = function(value, roundDown) {
    const rounder = roundDown ? Math.floor : Math.round
    value = rounder(parseFloat(value))
    if (isNaN(value)) {
        return DEFAULT_ERROR
    }
    return wgsdkThousands(value)
}

export const floats = function(value, digits = 1) {
    value = parseFloat(value)
    if (isNaN(value)) {
        return DEFAULT_ERROR
    }

    return wgsdkThousands(round(value, digits))
}

export const formatPercent = function(value) {
    const formatting = formats()
    const percent = formatting ? formatting.percent : '%'
    const isPercentBefore = formatting && formatting.percentBefore

    const parsedValue = parseFloat(value)
    if (isNaN(parsedValue)) {
        return DEFAULT_ERROR
    }

    let text = wgsdkThousands(value)

    text = isPercentBefore ? `${percent}${text}` : `${text}${percent}`

    return text
}

export const percent = function(value, fixed = 2) {
    value = parseFloat(value)
    if (isNaN(value)) {
        return DEFAULT_ERROR
    }
    value = parseFloat(value.toFixed(fixed))

    return formatPercent(value)
}

export const percentFloatToFixed = function(value, fixed = 2) {
    value = parseFloat(value)
    if (isNaN(value)) {
        return DEFAULT_ERROR
    }

    value = value.toFixed(fixed)

    return formatPercent(value)
}

export const toRoman = function(value) {
    return ROMANS[value]
}

export const toArabic = function(value) {
    return ROMANS.indexOf(value)
}

export const round = (value, ndigits) => {
    const shift = Math.pow(10, ndigits)
    return Math.round(value * shift) / shift
}

export const floatToFixed = function(value, fixed = 2) {
    value = parseFloat(value)
    if (isNaN(value)) {
        return DEFAULT_ERROR
    }

    return wgsdkThousands(value.toFixed(fixed))
}



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/helpers/format_number.js